import { Component, input } from '@angular/core';
import { Order } from '../order.model';
import { IconComponent } from '../../../shared/icon/icon.component';

@Component({
  selector: 'app-order-location',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './order-location.component.html',
  styleUrls: ['./order-location.component.css']
})
export class OrderLocationComponent {
  order = input.required<Order>();
}